<script setup>
import SportLiveTvFilterOption from '@/sport-live-tv/components/sport-live-tv-filter-option.vue';
import SportLiveTvSearchField from '@/sport-live-tv/components/sport-live-tv-search-field.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  title: { type: String, required: true },
  searchPlaceholder: { type: String, required: true },
  options: { type: Array, required: true },
  selected: { type: Array, required: true },
  search: { type: String, default: '' },
});

const emit = defineEmits(['toggle', 'update:search']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="sport-live-tv-filter-group">
    <p class="sport-live-tv-filter-group__title">{{ title }}</p>
    <SportLiveTvSearchField :model-value="search" :label="searchPlaceholder" @update:model-value="emit('update:search', $event)" />
    <div class="sport-live-tv-filter-group__list">
      <template v-if="options.length">
        <SportLiveTvFilterOption v-for="option in options" :key="option.value" :label="option.label" :checked="selected.includes(option.value)" @toggle="emit('toggle', option.value)" />
      </template>
      <p v-else class="sport-live-tv-filter-group__empty">{{ t('noMatches') }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;

  &__title {
    margin: 0;
    color: $white;
    font-size: 13px;
    font-weight: 600;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 224px;
    padding-right: 4px;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-width: thin;

    @include mobile-sm-max {
      max-height: 50vh;
    }
  }

  &__empty {
    margin: 0;
    padding: 8px 12px;
    color: $gray;
    font-size: 13px;
  }
}
</style>
